export default "__VITE_ASSET__DkMu1XFa__"